import React from 'react';
import styled from 'styled-components';

import { bool } from 'prop-types';

const StyledSvg = styled.svg`
  cursor: ${({ cursor }) => cursor || 'default'};
`;

const Settings = ({ pointer }) => (
  <StyledSvg
    pointer={pointer}
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3948 12.7475L17.5939 12.0801C17.1045 11.6796 16.8375 11.0567 16.882 10.4338C16.882 10.3003 16.882 10.1446 16.882 10.0111C16.882 9.87764 16.882 9.72191 16.882 9.58843C16.8598 8.96552 17.1267 8.3426 17.5939 7.94216L18.3948 7.27475C18.773 6.96329 18.8842 6.42937 18.6395 6.00667L17.4827 4.00445C17.2379 3.58176 16.7263 3.40378 16.2813 3.58176L15.2802 3.93771C14.6796 4.16018 14.0344 4.09344 13.5005 3.73749C13.2557 3.58176 13.011 3.42603 12.7663 3.31479C12.2101 3.02558 11.8097 2.49166 11.6985 1.86874L11.5205 0.867631C11.4093 0.355951 10.9866 0 10.4971 0H8.20569C7.71626 0 7.29357 0.355951 7.20458 0.845384L7.0266 1.8465C6.93762 2.46941 6.55942 3.00334 6.00324 3.29255C5.73628 3.42603 5.49156 3.55951 5.2691 3.71524C4.73517 4.04894 4.06776 4.13793 3.48934 3.91546L2.48823 3.55951C2.04329 3.40378 1.53161 3.58176 1.28689 3.9822L0.130052 5.98443C-0.114665 6.40712 -0.00342994 6.94105 0.374768 7.2525L1.17566 7.91991C1.66509 8.32036 1.93205 8.94327 1.88756 9.56618C1.88756 9.69967 1.88756 9.8554 1.88756 9.98888C1.88756 10.1224 1.88756 10.2781 1.88756 10.4116C1.90981 11.0345 1.64284 11.6574 1.17566 12.0578L0.374768 12.7253C-0.00342994 13.059 -0.114665 13.5929 0.130052 14.0156L1.28689 16.0178C1.53161 16.4405 2.04329 16.6185 2.48823 16.4405L3.48934 16.0845C4.09001 15.8621 4.73517 15.9288 5.2691 16.2848C5.51381 16.4405 5.75853 16.5962 6.00324 16.7075C6.55942 16.9967 6.95986 17.5306 7.0711 18.1535L7.24907 19.1546C7.33806 19.644 7.76075 20 8.25018 20H10.5416C11.0311 20 11.4537 19.644 11.5427 19.1546L11.7207 18.1535C11.8319 17.5306 12.2101 16.9967 12.7886 16.7075C13.0555 16.574 13.3002 16.4405 13.5227 16.2848C14.0566 15.9511 14.724 15.8621 15.3025 16.0845L16.3036 16.4405C16.7485 16.574 17.2157 16.396 17.4604 16.0178L18.6173 14.0156C18.862 13.5929 18.773 13.059 18.3948 12.7475ZM9.38478 13.0145C7.71626 13.0145 6.38144 11.6574 6.38144 10.0111C6.38144 8.36485 7.71626 7.00779 9.38478 7.00779C11.0533 7.00779 12.3881 8.3426 12.3881 10.0111C12.3881 10.812 12.0767 11.5684 11.4982 12.1468C10.9198 12.7252 10.1634 13.0145 9.38478 13.0145Z"
      fill="black"
    />
  </StyledSvg>
);

Settings.propTypes = {
  pointer: bool,
};

Settings.defaultProps = {
  pointer: null,
};

export default Settings;
